import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { FaEdit, FaTrash, FaEye, FaRedo } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import "./CarModal.css";
import axios from "../../utils/AxiosInstance";
import { useNavigate } from "react-router-dom";

const CarCrudModal = () => {
  
  const [cars, setCars] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  // Search and filter

  const [search, setSearch] = useState("");
  const [isActiveFilter, setIsActiveFilter] = useState("");

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
 
  //fetchCategries-stars

  const fetchCategories = async () => {
    try {
      const res = await axios.get("/admin/category/getall", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setCategories(res.data.data.data || []);
    } catch (error) {
      console.error("Fetch categories error:", error);
    }
  };

  //fetchCategries-ends

  const fetchCars = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/car/get-all?page=${page}&limit=${limit}&search=${search}&isActive=${isActiveFilter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log(res.data.data.data);
      // console.log(res.data.data.totalPages);
      // console.log(res.data.data.totalCount);
      // console.log(res);

      setCars(res.data.data.data || []);
      setTotalPages(res.data.data.totalPages || 1);
    } catch (error) {
      console.error("Fetch cars error:", error);
      toast.error(error.response?.data?.message || "Failed to fetch cars");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setShowModal(true);
    setEditMode(false);
    setEditData(null);
  };

  const handleEdit = (car) => {
    setEditData(car);
    setEditMode(true);
    setShowModal(true);
  };
  // console.log(editMode);

  const handleDelete = async () => {
    setIsSubmitting(true);
    try {
      const res = await axios.delete(`/car/delete/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (res.status === 200) {
        setCars((prev) => prev.filter((car) => car._id !== deleteId));
        toast.success("Deleted successfully");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error(error.response.data.message);
    } finally {
      setShowDeleteModal(false);
      setIsSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    brand: Yup.string().required("Brand is required"),
    model: Yup.string().required("Model is required"),
    category: Yup.string().required("Category is required"),
    registerNumber: Yup.string(),
    color: Yup.string(),
    kilometerDriven: Yup.number(),
    price: Yup.number().required("Price is required"),
    mileage: Yup.number().required("Mileage is required"),
    year: Yup.number()
      .min(1900)
      .max(new Date().getFullYear() + 1)
      .required("Year is required"),
    fuelType: Yup.string().required("Fuel type is required"),
    transmission: Yup.string().required("Transmission is required"),
    ownerCount: Yup.number(),
    description: Yup.string(),
    isActive: Yup.boolean(),

    images: Yup.array()
      .of(
        Yup.string()
          .trim()
          .required("Image URL is required")
          .url("Must be a valid URL")
      )
      .min(1, "At least one image URL is required")
      .test(
        "at-least-one-non-empty",
        "At least one image URL must be provided",
        (arr) => arr && arr.filter((val) => val && val.trim() !== "").length > 0
      ),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setIsSubmitting(true);

    console.log(values);

    try {
      if (editMode) {
        const res = await axios.put(`/car/update/${editData._id}`, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(res.data.data);

        setCars((prev) =>
          prev.map((car) => (car._id === editData._id ? res.data.data : car))
        );
        toast.success("Updated successfully");
      } else {
        const res = await axios.post("/car/create", values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const newCar = res.data?.data;
        // console.log(newCar);

        // console.log(newCar);

        if (newCar && newCar._id) {
          setCars((prev) => [newCar, ...prev]);

          toast.success("Added successfully");
        } else {
          console.warn("Car created but response has no _id:", newCar);
          toast.error("Unexpected response from server");
        }
      }

      setShowModal(false);
      resetForm();
    } catch (error) {
      console.error(" error:", error.response?.data?.message || error.message);
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
      setIsSubmitting(false);
    }
  };

  // PAGINATION-ELIPS-STARTS
  // console.log(search);
  console.log(isActiveFilter);

  const pages = [];

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);

    if (page > 3) pages.push("...");

    let startPage = Math.max(2, page - 1);
    let endPage = Math.min(totalPages - 1, page + 1);

    for (let i = startPage; i <= endPage; i++) pages.push(i);

    if (page < totalPages - 2) pages.push("...");

    pages.push(totalPages);
  }

  // PAGINATION-ELIPS-ENDS

  const handleChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePrevChange = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextChange = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };
  const handleReset = () => {
    setSearch("");
  };
  const handleSelectSearch = (e) => {
    setIsActiveFilter(e.target.value);
    setPage(1);
  };

  const disabledPrev = page === 1;
  const disabledNext = page === totalPages;

  // console.log(search);
  // console.log(page);

  useEffect(() => {
    fetchCars();
    fetchCategories();
  }, [page, search, isActiveFilter]); // cars ka data refresh hota hai

  return (
    <div className="container mt-4">
      <h4 className="text-center">Admin Panel -Car Management</h4>

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div className="d-flex align-items-center gap-2 flex-nowrap">
          <input
            type="text"
            placeholder="Please Search"
            className="form-control"
            style={{ minWidth: "200px", maxWidth: "250px" }}
            value={search}
            onChange={(e) => handleSearch(e)}
          />

          <Button
            variant="warning"
            size="sm"
            onClick={handleReset}
            className="d-flex align-items-center justify-content-center px-4"
            style={{ height: "38px" }}
          >
            <FaRedo />
          </Button>

          <select
            className="form-select"
            style={{ minWidth: "140px", maxWidth: "160px", height: "38px" }}
            value={isActiveFilter}
            onChange={handleSelectSearch}
          >
            <option value="">All Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>

        {/* Right Side Add Button */}
        <Button variant="success" onClick={handleAdd}>
          Add Car
        </Button>
      </div>

      {/* Car Table */}

      {loading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <table className="table table-bordered">
          <thead className="table-dark">
            <tr>
              <th>No</th>
              <th>Title</th>
              <th>Brand</th>
              <th>Model</th>
              <th>Category</th>
              <th>Price</th>
              <th>Year</th>
              <th>Status</th>

              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {cars
              .filter((car, index) => car && car._id)
              .map((car, index) => (
                <tr key={car._id}>
                  <td>{(page - 1) * limit + index + 1}</td>

                  <td>{car?.title}</td>
                  <td>{car?.brand}</td>
                  <td>{car?.model}</td>
                  <td>{car?.category?.name || "N/A"}</td>
                  <td>{car?.price}</td>
                  <td>{car?.year}</td>
                  <td>{car.isActive ? "Active" : "Inactive"}</td>

                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEdit(car)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => {
                        setDeleteId(car._id);
                        setShowDeleteModal(true);
                      }}
                    >
                      <FaTrash />
                    </Button>
                    <Button
                      variant="info"
                      size="sm"
                      className="ms-2"
                      onClick={() =>
                        navigate(`/admin-dashboard/cars/details/${car._id}`)
                      }
                    >
                      <FaEye />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}

      {/* pagination buttons */}

      <ToastContainer />

      <div className="d-flex justify-content-center gap-2 my-5">
        <button
          className="btn btn-success"
          onClick={handlePrevChange}
          disabled={disabledPrev}
        >
          Prev
        </button>

        {pages.map((pg, i) => (
          <button
            key={i}
            disabled={pg === "..."}
            onClick={() => typeof pg === "number" && handleChange(pg)}
            className={`btn ${
              pg === page
                ? "btn-dark"
                : pg === "..."
                ? "btn-secondary"
                : "btn-light"
            } rounded-0`}
          >
            {pg}
          </button>
        ))}

        <button
          className="btn btn-success"
          onClick={handleNextChange}
          disabled={disabledNext}
        >
          Next
        </button>
      </div>
      {/* pagination buttons-ends here */}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? "Edit Car" : "Add Car"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="my-modal-body">
          <Formik
            initialValues={{
              title: editData?.title || "",
              brand: editData?.brand || "",
              model: editData?.model || "",
              category: editData?.category?._id || "",
              registerNumber: editData?.registerNumber || "",
              color: editData?.color || "",
              kilometerDriven: editData?.kilometerDriven || "",
              price: editData?.price || "",
              mileage: editData?.mileage || "",
              year: editData?.year || "",
              fuelType: editData?.fuelType || "",
              transmission: editData?.transmission || "",
              ownerCount: editData?.ownerCount || 0,
              description: editData?.description || "",
              images: editData?.images?.length > 0 ? editData.images : [""],
              isActive: editData?.isActive ?? true,
            }}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                {[
                  "title",
                  "brand",
                  "model",
                  "registerNumber",
                  "color",
                  "kilometerDriven",
                  "price",
                  "mileage",
                  "year",
                  "ownerCount",
                  "description",
                ].map((name) => (
                  <div className="mb-2" key={name}>
                    <label>
                      {name.charAt(0).toUpperCase() + name.slice(1)}
                    </label>
                    <Field name={name} className="form-control" />
                    <ErrorMessage
                      name={name}
                      component="div"
                      className="text-danger"
                    />
                  </div>
                ))}
                <div className="mb-2">
                  <label>Category</label>
                  <Field as="select" name="category" className="form-control">
                    <option value="">Select category</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="category"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-2">
                  <label>Image URLs</label>
                  <FieldArray name="images">
                    {({ push, remove, form }) => (
                      <div className="mb-3">
                        {form.values.images.map((url, index) => (
                          <div key={index} className="d-flex mb-2">
                            <Field
                              name={`images[${index}]`}
                              className="form-control me-2"
                              placeholder={`Image URL ${index + 1}`}
                            />
                            <Button
                              variant="danger"
                              onClick={() => remove(index)}
                              disabled={form.values.images.length === 1}
                            >
                              -
                            </Button>
                          </div>
                        ))}
                        <Button variant="info" onClick={() => push("")}>
                          + Add Image
                        </Button>
                        <ErrorMessage
                          name="images"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="mb-2">
                  <label>Fuel Type</label>
                  <Field as="select" name="fuelType" className="form-control">
                    <option value="">Select</option>
                    <option value="Petrol">Petrol</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Electric">Electric</option>
                    <option value="Hybrid">Hybrid</option>
                    <option value="CNG">CNG</option>
                  </Field>
                  <ErrorMessage
                    name="fuelType"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-2">
                  <label>Transmission</label>
                  <Field
                    as="select"
                    name="transmission"
                    className="form-control"
                  >
                    <option value="">Select</option>
                    <option value="Manual">Manual</option>
                    <option value="Automatic">Automatic</option>
                  </Field>
                  <ErrorMessage
                    name="transmission"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="form-check mb-3">
                  <Field
                    type="checkbox"
                    name="isActive"
                    className="form-check-input"
                    id="isActive"
                  />
                  <label className="form-check-label" htmlFor="isActive">
                    Active
                  </label>
                </div>

                <div className="text-end">
                  <Button
                    variant="secondary"
                    className="me-2"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="success"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting
                      ? "Saving..."
                      : editMode
                      ? "Update"
                      : "Create"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this car?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default CarCrudModal;
